import { render, staticRenderFns } from "./ItemsEditor.vue?vue&type=template&id=469bb418&scoped=true"
import script from "./ItemsEditor.vue?vue&type=script&lang=js"
export * from "./ItemsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469bb418",
  null
  
)

export default component.exports